/**
 * Billing-management access while paid application access is suspended.
 *
 * A locked-out (non-driver) account owner may reach exactly one protected
 * route — the subscription/billing page — so they can pay, update their card
 * or cancel. Every other protected route stays locked.
 */
export const BILLING_MANAGEMENT_ROUTE = "/subscription-status";

export const isBillingManagementRoute = (pathname: string): boolean =>
  pathname === BILLING_MANAGEMENT_ROUTE || pathname === `${BILLING_MANAGEMENT_ROUTE}/`;

/** True when a user WITHOUT paid access may still render this route. */
export const lockedUserMayRender = (pathname: string, role: string | null | undefined): boolean =>
  role !== "driver" && isBillingManagementRoute(pathname);

/** DB subscription statuses that mean "billing needs attention" (Stripe unpaid is stored as expired). */
export const BILLING_ATTENTION_STATUSES = ["past_due", "unpaid", "expired"] as const;

export const needsBillingAttention = (status: string | null | undefined): boolean =>
  !!status && (BILLING_ATTENTION_STATUSES as readonly string[]).includes(status);

export const APPLE_SUBSCRIPTION_MANAGEMENT_URL = "https://apps.apple.com/account/subscriptions";
